export default {
  '--app-primary-color': 'hsl(203, 99%, 32%)',
  '--app-secondary-color': 'hsl(203, 70%, 25%)',
  '--app-tertiary-color': 'hsl(203, 55%, 69%)',
  '--app-disabled-color': 'hsl(0, 0%, 82%)',
  '--sidebar-bg-color': 'hsl(203, 100%, 37%)',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': 'hsl(171, 59%, 63%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 0%)'
};
